var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 10 10"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 5.015L4.965 10 3.802 8.83l2.981-3.002H0V4.172h6.783l-2.98-3.001L4.964 0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }